<template>
  <div class="wrapper">
    <div class="verify-wrap">
      <p>Policy verification</p>
      <div class="blankLine border-1px"></div>
      <div class="infoWarp">
        <div class="inputInfoWrap">
          <img src="../../assets/common/img/checkout_icon_passport.png" alt="">
          <mt-field class="info border-1px" placeholder="Passport number" type="text" v-model.trim="idNo"></mt-field>
        </div>

        <div class="inputInfoWrap">
          <img src="../../assets/common/img/Verificationcode.png" alt="">
          <mt-field class="info border-1px" placeholder="Verification code" type="text" v-model.trim="vncode"></mt-field>
        </div>
        <div class="searchBtn">
          <mt-button type="primary" :class="!idNo? '': 'active'" @click.native="handleSearch">Search</mt-button>
        </div>

        <div class="demoWrap" @click="isShowDemo=true">
          <img src="../../assets/common/img/iconInfo.png" alt="">
          <span>Verification demo</span>
        </div>
      </div>

    </div>
    <!--<div class="footlogo"><img src="../../assets/common/img/iconIogo.png" alt=""></div>-->

    <div class="demomaskWrap" v-if="isShowDemo">
      <div class="demomask">
        <div class="demotop">
        </div>
        <div class="demofoot" @click="isShowDemo=false"><p>I know</p></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Field, Button, Radio, Toast } from 'mint-ui';
import INTERFACE from '@/interface'

Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
Vue.component(Radio.name, Radio);
// Vue.use(Field)
export default {
  data() {
    return {
      isShowDemo: true,
      I18n: window.I18n,
      username: 'Policy verification',
      idNo: '',
      vncode: '',
      password: '',
      phone: '',
      website: '',
      number: '',
      birthday: '',
      verifyNo: '',
      introduction: ''
    };
  },
  watch: {
  },
  methods: {
    handleSearch() {
      if (!this.idNo) {
        Toast({
          message: 'Please enter your passport number!',
          iconClass: 'icon icon-error'
        });
        return
      }
      if (!this.vncode) {
        Toast({
          message: 'Please enter your Verification code!',
          iconClass: 'icon icon-error'
        });
        return
      }
      INTERFACE.getPolicyIstrue({ verifyNo: this.vncode.toUpperCase(), idNo: this.idNo.toUpperCase() }).then((data) => {
        if (data.data && data.data.policyId) {
          this.$router.push({
            path: '/policydetail',
            query: { policyId: data.data.policyId }
          })
        } else {
          Toast({
            message: 'No Policy Found!',
            iconClass: 'icon icon-error'
          });
        }
      })
    }
  },
  created() {
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "./style/index.styl";
input[type="text"],input[type="password"] {
  -webkit-appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/InsurancePolicy/index.vue